/**
 * 价格组成
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/15      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import {isEmptyObject} from '@utils/utils';
import { Popover,Tooltip } from "antd";
import "./index.less";
import OneCoupon from "@components/Coupon/one-coupon-antd/index-antd.js";
import {symbolMoneyUtil, toFixed2} from '@utils/utils';
class PriceComposition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            model: props.model,
            visible: false,
            loading: false,
        };
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = (visible) => {
        this.setState({ visible });
    };

    renderDigital(){
        const {model} = this.state;
        return ( <div className="price-composition-wrap">
            <div>
                {
                    ((!model.id&&!model.orderType)||(model.id&&!model.flag))?
                        <div className="box">
                            <span className="name">{__getServerLanguage('ShangPin')}</span>
                            <span className="price">
                                {/*{numberWithCommas(toFixedWithCommas(model.exwPriceTotal,2))} {model.currencySymbol}*/}
                                {symbolMoneyUtil(model.exwPriceTotal, model.currencySymbol)}
                            </span>
                        </div>
                        :
                        <div className="box">
                            <span className="name">{__getServerLanguage('YuanDingDanJinE')}</span>
                            <span className="price">
                                {/*{numberWithCommas(toFixedWithCommas(model.beforeDiscountTotalPrice,2))} {model.currencySymbol}*/}
                                {symbolMoneyUtil(model.beforeDiscountTotalPrice, model.currencySymbol)}
                            </span>
                        </div>
                }


                {
                    model.noCertificateSplit!=1&&(this.props.totalTaxes||model.totalTaxes)?
                        <div className="box">
                            <span></span>
                            <span className="tip">{__getServerLanguage('BaoHanShuiFei')}
                                {/*{numberWithCommas(toFixedWithCommas(this.props.totalTaxes||model.totalTaxes,2))} {model.currencySymbol}*/}
                                {symbolMoneyUtil(this.props.totalTaxes||model.totalTaxes, model.currencySymbol)}
                            </span>
                        </div>
                        :
                        null
                }




            </div>

            {
                ((!model.id&&!model.orderType)||(model.id&&!model.flag))?
                    <div className="box box-line-grey">
                        <span className="name">{__getServerLanguage('WuLiuQingGuanFei')}</span>
                        <span className="price">
                            {/*{numberWithCommas(toFixedWithCommas(model.logisticsPriceTotal,2))} {model.currencySymbol}*/}
                            {symbolMoneyUtil(model.logisticsPriceTotal, model.currencySymbol)}
                        </span>
                    </div>
                    :
                    null
            }
            {/*已优惠*/}
            {
                (this.props.discountPriceTotal||model.discountPriceTotal)?
                    (
                        ((!model.id&&!model.orderType)||(model.id&&!model.flag))?
                            <div className="box box-line-grey">
                                    <span className="name flex-item-ver-center">{__getServerLanguage('YouHui2')}
                                        {/*{numberWithCommas(toFixedWithCommas(this.props.discountPriceTotal||model.discountPriceTotal,2))} {model.currencySymbol}*/}
                                        {/* 优惠券 */}
                                        {isEmptyObject(model.mcCouponVO)?null:<Tooltip placement="top"
                                                                                       overlayClassName={"pink-coupon-item-pop"}
                                                                                       title={<OneCoupon key={model.mcCouponVO.id}
                                                                                                         UserOtherStyle='pink-coupon-item'
                                                                                                         couponItem={model.mcCouponVO}>
                                        </OneCoupon>}>
                                            <span className="icon iconfont icon-Vector1 ml_4 black33"></span>
                                        </Tooltip>}
                                    </span>
                                    <span className="price color-red">
                                        - {symbolMoneyUtil(this.props.discountPriceTotal||model.discountPriceTotal, model.currencySymbol)}
                                    </span>
                            </div>
                            :
                            <div className="box box-line-grey">
                                    <span className="name flex-item-ver-center">{__getServerLanguage('YouHuiJinE')} -
                                        {/*{numberWithCommas(toFixedWithCommas(this.props.discountPriceTotal||model.discountPriceTotal,2))} {model.currencySymbol}*/}
                                    </span>
                                    <span className="price color-red">
                                        - {symbolMoneyUtil(this.props.discountPriceTotal||model.discountPriceTotal, model.currencySymbol)}
                                    </span>
                            </div>

                    )
                    :
                    null
            }
            {/*积分抵扣*/}
            {
                (this.props.pointTotalPrice||model.pointTotalPrice)?
                    <div className="box box-line-grey">
                            <span className="name flex-item-ver-center">{__getServerLanguage('JiFenDiKou')}
                                {/* 本单使用 230 积分抵扣 230.00 ₽ */}
                                <Tooltip placement="top" title={__getServerLanguage('BenDanShiYongJiFenDiKou',model.pointTotal,symbolMoneyUtil(model.pointTotalPrice, model.currencySymbol))}>
                                    <span className="icon iconfont icon-Vector1 ml_4 black33"></span>
                                </Tooltip>
                            </span>
                        <span className="price color-red">
                                {/*{numberWithCommas(toFixedWithCommas(this.props.pointTotalPrice||model.pointTotalPrice,2))} {model.currencySymbol}*/}
                            - {symbolMoneyUtil(this.props.pointTotalPrice||model.pointTotalPrice, model.currencySymbol)}
                            </span>
                    </div>
                    :
                    null
            }
            <div className="box box-line fw_700 black89">
                <div className="font_14">{__getServerLanguage('ZongJi')}</div>
                <div className="font_16 text-right">
                    {/*{numberWithCommas(toFixedWithCommas(this.props.totalPrice||model.totalPrice,2))} {model.currencySymbol} */}
                    <div>{symbolMoneyUtil(this.props.totalPrice||model.totalPrice, model.currencySymbol)}</div>
                    {(model.fxCommissionPrice&&model.fxCommissionPrice>0)?<div className={"black66 fw_400"}>
                        <span className={"mr_8 font_14"}>{__getServerLanguage('YuJiTiCheng')}</span>{symbolMoneyUtil(toFixed2(model.fxCommissionPrice),model.currencySymbol)}
                    </div>:null}
                </div>
            </div>
        </div>)
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            model: nextProps.model,
        });
    }

    render() {
        let { model } = this.state;
        const { noPopover } = this.props;
        return (
            noPopover?this.renderDigital():<Popover
                autoAdjustOverflow={false}
                content={this.renderDigital()}
                title={false}
                trigger="click"
                open={this.state.visible}
                placement="bottomRight"
                arrow={true}
                onOpenChange={this.handleVisibleChange}
            >
                {this.props.children}
            </Popover>
        );
    }
}

PriceComposition.defaultProps = {
    model: {},
    totalPrice: null,
    //优惠
    discountPriceTotal: "",
    noPopover: false, // 非泡泡模式，即直接 显示泡泡内文本
};

PriceComposition.propTypes = {
    model: PropTypes.object,
    totalPrice: PropTypes.number,
};
export default PriceComposition;
